// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from "./common/Axios";
import './assets/scss/reset.scss';
import DefaultFotter from "@/components/DefaultFotter";
import {group} from "@/common/public.js";
import {MessageBox ,Message,Pagination,Loading } from 'element-ui';//引入分页组件
import vuescroll from 'vuescroll';
Vue.config.productionTip = false;
/* eslint-disable no-new */
Vue.use(Pagination);
Vue.use(vuescroll);
Vue.component("DefaultFotter", DefaultFotter);//全局自定义组件
Vue.prototype.$group = group;
Vue.prototype.$Message = Message;
Vue.prototype.$axios = axios;
Vue.prototype.$vuescrollConfig = {
  vuescroll: {
    mode: 'native',//模式
    sizeStrategy: 'percent',
    detectResize: true,//是否检测内容尺寸发生变化。
    wheelDirectionReverse: true//是否使滚轮方向相反
  },
  rail: {//滚动条移动所在位置。
    background: '#f2f2f2',
    opacity: 1,//轨道的透明度。
    size: '10px',//轨道的尺寸
    specifyBorderRadius: "0",//是否指定轨道的 borderRadius， 如果不那么将会自动设置
    gutterOfEnds: null,//轨道距 x 和 y 轴两端的距离。
    gutterOfSide: '0',//距离容器的距离。
    keepShow: false//是否即使 bar 不存在的情况下也保持显示
  },
  bar: {//滚动条，类似于原生的滚动条。
    onlyShowBarOnScroll: true,//是否只在滚动时显示 bar。
    showDelay: 500,//在鼠标离开容器后多长时间隐藏滚动条
    background: '#cccccc',//滚动条背景色。
    keepShow: true,//滚动条是否保持显示。
    opacity: 1,//滚动条透明度。
    hoverStyle: false,
    specifyBorderRadius: "0",//是否指定滚动条的 borderRadius， 如果不那么和轨道的保持一致
    minSize: false,
    size: '10px',//bar 的尺寸
    disable: false,//是否禁用滚动条。
  },
  scrollButton: {
    enable: true,//是否启用 scrollButton.
    background: '#cccccc',//scrollButton 的背景色
    opacity: 1,//scrollButton 的透明度。
    step: 180,//每次当你点击 scrollButton 所滚动的距离
    mousedownStep: 30//每次当你按住 scrollButton 所滚动的距离
  },
};
router.beforeEach((to, from, next) => {
  var ismobile = localStorage.getItem('ismobile');
    if(ismobile == null){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      ismobile = flag ? 1 : 0
    }
    // 电脑
    if (ismobile == 0) {
      next();
    }
    // 手机
    if (ismobile == 1) {
      location.href=`https://df-ydtg.yunlib.cn${window.location.pathname}${window.location.search}`;
    }
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js